import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { ApiService } from './api.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private _api: ApiService, private router: Router) {
  }
  public VerificarLogin: boolean=true;

  public isTokenValid(): Observable<boolean> {
    if(!this.VerificarLogin){
      return of(true);
    };

    return this._api.postTypeRequest('login/test-token', {}).pipe(
      map(response => true),
      catchError(error => {
        if (error.status === 401) { // Unauthorized
          this.clearStorage();
          this.router.navigate(['/login']);
        };
        // Apenas retorna false em caso de erro, sem redirecionar
        return of(false);
      })
    );
  };

  getUserDetails() {
    return localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;
  };

  setDataInLocalStorage(variableName, data) {
    localStorage.setItem(variableName, data);
  };

  getToken() {
    if(!this.VerificarLogin){
      return 'abcd';
    };
    return localStorage.getItem('token');
  };

  clearStorage() {
    localStorage.clear();
  };
}